// src/pages/ventas/VentaDetailPage.tsx
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { VentaDetailModal } from './VentaDetailModal';
import { VentasApi } from '../../../services/api/VentasApi';
import { toast } from '../../../utils/toast';

export const VentaDetailPage: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [venta, setVenta] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const cargarVenta = async () => {
      try {
        const ventaId = id || '0';
        if (!ventaId) {
          throw new Error('ID de venta inválido');
        }

        const response = await VentasApi.getVentaById(ventaId);
        if (response) {
          setVenta(response);
        }
      } catch (error) {
        console.error('Error cargando venta:', error);
        toast.error('No se pudo cargar la información de la venta');
        navigate('/ventas'); // Redirigir al listado en caso de error
      } finally {
        setLoading(false);
      }
    };

    cargarVenta();
  }, [id, navigate]);

  const handleClose = () => {
    navigate('/ventas');
  };

  if (loading) {
    return <div>Cargando...</div>; // Puedes usar un componente de loading más elaborado
  }

  return (
    <VentaDetailModal
      venta={venta}
      open={true}
      onClose={handleClose}
    />
  );
};